import styled from 'styled-components';

export const ScrollOffset = styled.span`
  height: 0;
  position: absolute;
  top: -50px;
`;
